var _defs, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRoundedCalendarToday24Px(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#383838;}.b{fill:#fff;}.c{fill:none;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#383838",
    d: "M6.667,0A6.667,6.667,0,1,1,0,6.667,6.667,6.667,0,0,1,6.667,0Z",
    transform: "translate(1.333 1.333)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9,4.667H8V4H7.333v.667h-2V4H4.667v.667h-1A.669.669,0,0,0,3,5.333v5.333a.669.669,0,0,0,.667.667H9a.669.669,0,0,0,.667-.667V5.333A.669.669,0,0,0,9,4.667Zm0,6H3.667v-4H9Z",
    transform: "translate(1.667)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0,0H16V16H0Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundedCalendarToday24Px);
export default __webpack_public_path__ + "static/media/rounded_calendar_today-24px.3705ff78530269119996d03adf486db9.svg";
export { ForwardRef as ReactComponent };